import ApplicationEventHub from "../../events/applicationEventHub";
export default {
  namespaced: true,
  state: {
    visible : false,
    ready : false,
    isPlaying: false,
    subtitlesActive: false,
    subtitlesAvailable: false,
    transcriptActive: false,
    transcriptContent : null,
    volume: 100,
    currentProgress : 100,
    cameraDevice: null,
    audioOutputDevice: null,
    audioInputDevice: null,
  },
  mutations: {
    play(state){
      state.isPlaying=true;
    },
    pause(state){
      state.isPlaying=false;
    },
    activateSubtitles(state){
      state.subtitlesActive=true;
    },
    deactivateSubtitles(state){
      state.subtitlesActive=false;
    },
    activateTranscript(state){
      state.transcriptActive=true;
    },
    deactivateTranscript(state){
      state.transcriptActive=false;
    },
    setVolume(state, volume){
      state.volume=volume;
    },
    setMediaControlsReady(state, active){
      state.ready=active;
    },
    showMediaControls(state, active){
      state.visible=active;
    },
    setSubtitlesAvailable(state, available){
      state.subtitlesAvailable=available;
    },
    setCurrentProgress(state, currentProgress){
      state.currentProgress=currentProgress;
    },
    setTranscript(state, content) {
      state.transcriptContent=content;
    },
    setCameraDevice(state, device){
      state.cameraDevice = device;
    },
    setAudioOutputDevice(state, device){
      state.audioOutputDevice = device;
    },
    setAudioInputDevice(state, device){
      state.audioInputDevice = device;
    }
  },
  actions: {
    playing({commit}){
      commit('play');
    },
    paused({commit}){
      commit('pause');
    },
    setSubtitles({commit},active){
      if(active){
        commit('activateSubtitles');
      }else{
        commit('deactivateSubtitles');
      }
    },
    toggleTranscript({commit, state}){
      if(!state.transcriptActive){
        commit('activateTranscript');
      }
      else{
        commit('deactivateTranscript');
      }
    },
    setVolume({commit}, volume){
      commit('setVolume',volume);
      ApplicationEventHub.setMediaVolume(volume);
    },
    setMediaControls({commit}, active){
      commit('showMediaControls', active);
      if(!active){
        commit('deactivateTranscript', false);
        commit('setMediaControlsReady', false);
        commit('setSubtitlesAvailable', false);
        commit('setCurrentProgress', 100);
        commit('setTranscript', null);
      }
    },
    setMediaControlsReady({commit}){
      commit('setMediaControlsReady', true);
    },
    setSubtitlesAvailable({commit}){
      commit('setSubtitlesAvailable', true);
    },
    setProgress({commit},progress){
      commit('setCurrentProgress', progress);
    },
    setTranscript({commit},content){
      commit('setTranscript', content);
    },
    setAudioInputDevice({commit},device){
      commit('setAudioInputDevice', device);
    },
    setAudioOutputDevice({commit},device){
      commit('setAudioOutputDevice', device);
    },
    setCameraDevice({commit},device){
      commit('setCameraDevice', device);
    },
  },
  getters: {}
}
